import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[dianaTogglePassword]',
    standalone: false
})
export class TogglePasswordDirective implements AfterViewInit {
  private shown = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) { 
  }

  ngAfterViewInit(): void {
    this.setup();
  }

  private setup(): void {
    const parent = this.el.nativeElement.parentNode;
    const wrapper = this.renderer.createElement('div');
    this.renderer.setStyle(wrapper, 'position', 'static');
    const matIcon = this.renderer.createElement('mat-icon');
    this.renderer.addClass(matIcon, 'mat-icon');
    this.renderer.setStyle(matIcon, 'position', 'absolute');
    this.renderer.setStyle(matIcon, 'right', '0px');
    this.renderer.setStyle(matIcon, 'top', '50%');
    this.renderer.setStyle(matIcon, 'transform', 'translateY(-50%)');
    this.renderer.setStyle(matIcon, 'cursor', 'pointer');
    this.renderer.addClass(matIcon, 'material-icons');
    this.renderer.setProperty(matIcon, 'textContent', 'visibility');
    this.renderer.listen(matIcon, 'click', () => this.toggle(matIcon));
    this.renderer.appendChild(wrapper, matIcon);
    this.renderer.appendChild(parent, wrapper);
  }

  private toggle(icon: HTMLElement): void {
    this.shown = !this.shown;

    if (this.shown) {
      this.renderer.setProperty(this.el.nativeElement, 'type', 'text');
      this.renderer.setProperty(icon, 'textContent', 'visibility_off');
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'type', 'password');
      this.renderer.setProperty(icon, 'textContent', 'visibility');
    }
  }

}
